import React, {useEffect, useState} from 'react'
import ApplicationsData from "../../datas/Applications.json"
// import RippleButton from '../../../../components/Buttons/RippleButton'
import { BiFilter, BiSortAZ } from 'react-icons/bi'
import ico from "../../../assets/searchIcon/search.svg"
// import Dropdown from "../../../../components/Dropdown/Dropdown"
// import TrainingCard from '../../components/Skeleton/JobCardSkeleton'
// import TrainingCardSkeleton from '../../components/Skeleton/TrainingCardSkeleton'
import {FormationDatas} from "../../../datas/FormationDatas"
import StudentCard from '../../../components/Cards/FindTalentCard'
import { END_POINT  as api , USER_IMAGE_URL_END_POINT as path} from '../../../../utils/constant'
import axios from 'axios'
import { useSelector } from 'react-redux'
import ImageWithFallback from '../../../components/ImageWithFallback'
import { Link } from 'react-router-dom'
import { FaEye } from 'react-icons/fa'
import CandidateModal from '../../components/Modal/CandidateModal'
import { DropdownFilter, DropdownFilterItem } from '../../../../components/Form/DropdownFilter'
import * as XLSX from "xlsx";

const SavedCandidates = () => {
 
 
  
  // const CandidateList = () => {
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(false);
        const [showCandidateDetailModal, setCandidateDetailModal] = useState(false)
    const [activeTab, setActiveTab] = useState("candidats"); // 'candidats' ou 'favoris'
    const { user } = useSelector((store) => store.user);
  const [openDropdown, setOpenDropdown] = useState(null);
    const [filters, setFilters] = useState({
      keyword: "",
      status: "",
      dateRange: "",
      sort: "",
    });

    const toggleDropdown = (menu) => {
      setOpenDropdown(openDropdown === menu ? null : menu);
    };

        const handleSelect = (filterType, value) => {
          setFilters((prev) => ({ ...prev, [filterType]: value }));
        };
  
    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
          const apiUrl =
            activeTab === "favoris"
              ? `${api}/api/candidate/addedToFavorite/${2}` // A MODIFIER user.id
              : `${api}/api/candidate/${2}/all`; // A MODIFIER user.id
          const response = await axios.get(apiUrl);
          // activeTab === "favoris" ? setCandidates(response.data?) : setCandidates(response.data) 
          setCandidates(response.data) 
          
          console.log(response?.data)
        } catch (error) {
          console.error("Erreur lors de la récupération des données :", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, [activeTab, user.id]);

    const filteredCandidates = candidates
  .filter((candidate) =>
    candidate?.candidate_profile?.name?.toLowerCase().includes(filters.keyword.toLowerCase())
  )
  .sort((a, b) => {
    if (!filters.sort) return 0;
    return filters.sort === "Ordre croissant"
      ? a?.candidate_profile?.name?.localeCompare(b?.candidate_profile?.name)
      : b?.candidate_profile?.name?.localeCompare(a?.candidate_profile?.name);
  });

  const exportToExcel = () => {
    const formattedCandidates = filteredCandidates.map(candidate => ({
      "ID": candidate.id,
      "Nom": candidate.nom,
      "Email": candidate.email,
      "Téléphone": candidate.candidate_profile?.phone || "",
      "Genre": candidate.candidate_profile?.gender || "",
      "Adresse": candidate.candidate_profile?.address || "",
      "Niveau d'études": candidate.candidate_profile?.level || "",
      "Diplôme le plus élevé": candidate.candidate_profile?.highest_diploma || "",
      "Poste actuel": candidate.candidate_profile?.current_job || "",
      "Entreprise actuelle": candidate.candidate_profile?.work_at || "",
      "Compétences": candidate.candidate_profile?.resume_skills
        ? candidate.candidate_profile.resume_skills.map(skill => skill.name).join(", ")
        : "",
      "Statut de la dernière candidature": candidate.latest_application?.status || "",
      "Titre de l'offre postulée": candidate.latest_application?.offer?.job_title || "",
      "Portfolio": candidate.latest_application?.portfolio_url || "",
      "Date d'inscription": new Date(candidate.created_at).toLocaleDateString(),
    }));
  
    const ws = XLSX.utils.json_to_sheet(formattedCandidates);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Candidats");
    XLSX.writeFile(wb, "Liste_Candidats.xlsx");
  };
  

    // const exportToExcel = () => {
    //   const ws = XLSX.utils.json_to_sheet(filteredCandidates);
    //   const wb = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(wb, ws, "Candidats");
    //   XLSX.writeFile(wb, "Liste_Candidats.xlsx");
    // };
  
    return (
      <div className="layout-1">
        <h1 className="font-semibold mb-6 text-start">Liste des Étudiants</h1>
  
        <div className="flex justify-between items-center mb-4 gap-x-4">
          {/* Barre de recherche */}
          <div className="relative flex items-center w-full md:w-96 h-10 rounded-lg border overflow-hidden">
            <div className="grid place-items-center h-full w-12 text-gray-300">
            <img src={ico} alt="serachbtn" />
            </div>
            <input
              className="peer h-full w-full outline-none text-sm text-gray-700 pr-2"
              type="text"
              id="search"
              placeholder="Mot clé..."
            />
          </div>
  
          {/* Boutons pour changer d'onglet */}
          <div className="flex w-96 md:max-w-xl rounded shadow">
            <button
              onClick={() => setActiveTab("candidats")}
              className={`w-full flex justify-center font-medium rounded-l px-5 py-2 border ${
                activeTab === "candidats"
                  ? "bg-gray-900 text-white border-gray-900"
                  : "bg-white text-gray-800 border-gray-200 hover:bg-gray-100"
              }`}
            >
              Candidats
            </button>
  
            <button
              onClick={() => setActiveTab("favoris")}
              className={`w-full flex items-center gap-x-2 justify-center font-medium rounded-r px-5 py-2 border ${
                activeTab === "favoris"
                  ? "bg-gray-900 text-white border-gray-900"
                  : "bg-white text-gray-800 border-gray-200 hover:bg-gray-100"
              }`}
            >
              Favoris
              <svg
                className="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z"
                />
              </svg>
            </button>
          </div>
        </div>

           <DropdownFilter
                label={filters.sort || "Tri"}
                icon={<BiSortAZ />}
                isOpen={openDropdown === "sort"}
                onToggle={() => toggleDropdown("sort")}
              >
                <DropdownFilterItem
                  text="Ordre croissant"
                  onClick={() => handleSelect("sort", "Ordre croissant")}
                />
                <DropdownFilterItem
                  text="Ordre décroissant"
                  onClick={() => handleSelect("sort", "Ordre décroissant")}
                />
              </DropdownFilter>
              <button onClick={exportToExcel} className="bg-blue-500 text-white px-4 py-2 rounded">
  Exporter en Excel
</button>
  
        {/* Tableau des candidats */}
        <div className="w-full overflow-x-auto">
          <table className="text-sm whitespace-pre w-full text-start">
            <TableHeader context={activeTab} />
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    Chargement...
                  </td>
                </tr>
              ) : filteredCandidates?.length > 0 ? (
                filteredCandidates?.map((item) => (
                  <tr key={item.id} className="border-b border-gray-100 rounded">
                    <td className="py-3">
                      <div className="flex ml-5 items-center gap-2">
                        <input type="checkbox" className="w-4 h-4 rounded-lg" />
                        <div className="flex items-center gap-2 p-1.5 hover:bg-neutral-100 rounded-lg cursor-pointer">
                          <ImageWithFallback
                            src={`${path}${item?.photo}`}
                            alt="user"
                            defaultType="user"
                            className="w-9 h-9 rounded-full"
                          />
                          <div className="flex flex-col justify-between px-4">
                            <p className="text-base font-medium">{item?.candidate_profile?.name}</p>
                            <span className="text-xs">{item?.email}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                    {activeTab === "candidats" ? (
                      <>
                        <td className="pl-5">{item?.latest_application?.offer?.job_title || "N/A"}</td>
                        <td className="pl-5">
                          <p className="text-sm flex gap-1 items-center text-primary-text">
                            {item?.latest_application?.status || "Non défini"}
                          </p>
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="pl-5">
                          {/* {user?.skills || "N/A"} */}

                          <div className="flex flex-wrap gap-2 ">
                            {item?.candidate_profile?.resume_skills?.map((skill, index)=>{
                                if(index < 5)return(
                                    <div key={index} className="bg-neutral-50 text-neutral-500 text-sm px-2 py-1 border rounded-full">{skill?.name}</div>
                                )
                            })}

                            {
                                item?.candidate_profile?.resume_skills?.length > 5 && (
                                <div 
                                className="bg-neutral-50 text-primary-black text-sm px-2 py-1 border rounded-full">
                                {item?.candidate_profile?.resume_skills?.length - 5} et plus
                                </div>
                            )}
                            
                        </div>
                        </td>
                        <td className="pl-5">{item?.candidate_profile?.phone || "N/A"}</td>
                      </>
                    )}
                    <td className="pl-5">
                      <div className="flex items-center gap-2">
                        <button
                          // to={`/mira-formateur/etudiant/${user?.id}`}
                          onClick={()=>setCandidateDetailModal(true)}
                          className="flex items-center justify-center text-base text-neutral-500 font-medium bg-gray-50 border rounded-md p-2"
                        >
                          <FaEye />
                        </button>
                      </div>
                    </td>
                    <CandidateModal application={item} show={showCandidateDetailModal} onClose={()=>setCandidateDetailModal(false)}/>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    Aucun candidat trouvé
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        
      </div>
    );
  };  

export default SavedCandidates

const TableHeader = ({ context }) => {
  return (
    <thead>
      <tr className="text-left text-sm bg-neutral-100 rounded-sm">
        <th className="pl-5 bg-neutral-100 py-2">Candidat</th>
        {context === "candidats" ? (
          <>
            <th className="pl-5 bg-neutral-100 py-2">Dernière candidature</th>
            <th className="pl-5 bg-neutral-100 py-2">État</th>
          </>
        ) : (
          <>
            <th className="pl-5 bg-neutral-100 py-2">Compétence</th>
            <th className="pl-5 bg-neutral-100 py-2">Contact</th>
          </>
        )}
        <th className="pl-5 bg-neutral-100 py-2">Action</th>
      </tr>
    </thead>
  );
};